import { call, put, takeEvery } from 'redux-saga/effects';
import { postApiRequest } from '../../../../features/axiosClient';
import toast from 'react-hot-toast';
import { RESTORE_REQUEST } from '../../../../constants/ActionNameConstants';
import { restoreFailure, restoreSuccess } from '../actions/restoreAction';
import { VENDOR_TRANSCRIPT_SUBMIT_URL_COPY } from '../../../../constants/ApiUrlConstants';
import { getSlateDataSuccess, updateSlateDataLoadingState } from '../actions/slateDataActions';
import { getAllSpeakersRequest } from '../../Editor/actions';

// const restoreApi = (action) => postApiRequest(`${RESTORE_API_URL}?audioFileId=${action}`);
const restoreApi = (action) =>
  postApiRequest(`${VENDOR_TRANSCRIPT_SUBMIT_URL_COPY}`, {
    isClickOnClaim: false,
    isRestore: true,
    fileStatus: 'claimed',
    audioFileId: action.id,
  });
function* restoreSaga(action) {
  try {
    yield put(updateSlateDataLoadingState(true));
    const response = yield call(restoreApi, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    const jsonResponse = JSON.parse(response.data.value);
    yield put(restoreSuccess(jsonResponse.JsonTranscript));
    toast.success('The transcript has been successfully restored.');
    yield put(getSlateDataSuccess(jsonResponse.JsonTranscript));
    yield put(getAllSpeakersRequest(action.payload?.id));
  } catch (error) {
    yield put(restoreFailure(error.message));
  }
}

export function* watchRestore() {
  yield takeEvery(RESTORE_REQUEST, restoreSaga);
}
